export function notificationBarInit() {
	const notificationBarWrapper = document.querySelector( '.easy-notification-bar' );
	const language = getLanguage();
	let label;

	if ( language === 'en-GB' ) {
		label = 'Information';
	} else if ( language === 'fi' ) {
		label = 'Tiedotus';
	}

	// Don't run this script if notification bar is disabled.
	if ( notificationBarWrapper ) {
		// Role and aria-label attributes to notification bar.
		notificationBarWrapper.setAttribute( 'role', 'region' );
		notificationBarWrapper.setAttribute( 'aria-label', label );
	}

	// Language code from current page.
	function getLanguage() {
		return document.getElementsByTagName( 'html' )[ 0 ].getAttribute( 'lang' );
	}
}
